import React from "react";
import ArrowIcon from "@assets/icons/right-arrow-green.svg";
import styles from "./ensayo-thumbnail.module.scss";
import { useTranslation } from "next-i18next";
import { TemplateText, Text } from "../../atoms";
import { MainRouter } from "@config/urls";

export const EnsayoThumbnail = (props: any) => {
  const { slug, title, subtitle, image, country } = props;
  const { t } = useTranslation();
  return (
    <a
      href={`/${MainRouter["ensayos-detalle"].generatePath({
        id: slug,
        country: country,
      })}`}
    >
      <div style={{ backgroundImage: `url(${image})` }} className={styles.root}>
        <div className={styles.data}>
          <div>
            <TemplateText template="micro" className={styles.subtitle}>
              {subtitle}
            </TemplateText>
            <Text as="h3">{title.slice(0, 140)}</Text>
          </div>
          <p className={styles.link}>
            {t("EnsayoThumbnail.linkLabel")} <ArrowIcon />
          </p>
        </div>
      </div>
    </a>
  );
};
